<span
  class="tool-tip"
  *ngIf="canUploadExcel"
  [isDisabled]="form.form?.controls?.dbtrId?.value && form.form?.controls?.dbtrId?.valid"
  data-toggle="tooltip"
  data-placement="top"
  tooltip="{{visuals.selectDebtor}}"
>
  <button
    [disabled]="!form.form?.controls?.dbtrId?.value || !form.form?.controls?.dbtrId?.valid"
    type="button"
    class="btn btn-primary btn-shadowed mb-05"
    (click)="upload()"
  >
    <i class="fa fa-upload"></i> {{visuals.uploadExcel}}
  </button>
</span>
<dynamic-form
  [group]="group"
  [serviceName]="'ResendInvitationService'"
  [loading]="loading"
  [visuals]="visuals"
  [genericVisuals]="genericVisuals"
  [formErrors]="formErrors"
  #form="dynamicForm"
  (submit)="submit($event)"
  (modalOutput)="handleModalOutput($event)"
  (formChanges)="handleFormChanges($event)"
>
</dynamic-form>
<base-table-layout
  [records]="grid"
  [footer]="footer"
  [gridActions]="canPerformGridActions? gridActions: []"
  [hasRowCheckbox]="hasRowCheckbox"
  [settings]="columnSetting"
  [searched]="searched"
  [loading]="loading"
  [downloading]="downloading"
  [checkboxLoading]="checkboxLoading"
  [count]="count"
  [visuals]="visuals"
  [genericVisuals]="genericVisuals"
  (outputMethodHandler)="outputMethodHandler($event)"
  [sortNum]="sortNum"
  [sortDir]="sortDir"
  [secSortNum]="secSortNum"
  [secSortDir]="secSortDir"
  (changeSortHandler)="changeSort($event)"
  [pageSize]="pageSize"
  [pageNum]="pageNum"
  [pageMax]="pageMax"
  (changePageHandler)="changePage($event)"
  (changePageSizeHandler)="changePageSize($event)"
>
</base-table-layout>
<div
  bsModal
  #uploadModal="bs-modal"
  [config]="{backdrop: 'static'}"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{visuals.attachment}}</h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="uploadModal.hide()"
        >
          <span aria-hidden="true"><i class="fa fa-close"></i></span>
        </button>
      </div>
      <div class="modal-body card-block">
        <resendInvitationAttachment
          (refreshTableAfterSuccess)="refreshTable()"
          [debtorId]="form.form?.controls?.dbtrId?.value"
        ></resendInvitationAttachment>
        <u (click)="downloadExcel()" class="pointer">{{visuals.downloadTemplate}}</u>
        <u
          (click)="downloadBankExcel()"
          style="float:right;"
          class="pointer"
          >{{visuals.downloadBankTemplate}}</u
        >
      </div>
    </div>
  </div>
</div>

<div
  bsModal
  #rejectModal="bs-modal"
  [config]="{backdrop: 'static'}"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left"></h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="rejectModal.hide(); rejectionForm.reset()"
        >
          <span aria-hidden="true"><i class="fa fa-close"></i></span>
        </button>
      </div>
      <div class="modal-body card-block">
        <div class="card card-accent-primary shadowed">
          <div class="card-header">
            <strong>{{genericVisuals.enterRejectionReason}}</strong>
          </div>
          <div class="card-block">
            <ng-container *ngTemplateOutlet="formContent"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #formContent>
  <form [formGroup]="rejectionForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label class="input-required" for="rejectionReason">{{genericVisuals.rejectionReason}}</label>
      <textarea
        id="rejectionReason"
        [ngClass]="{'errorField': rejectionForm.controls.rejectionReason.invalid && rejectionForm.controls.rejectionReason.touched}"
        class="form-control"
        rows="5"
        formControlName="rejectionReason"
      ></textarea>
      <div
        class="error"
        *ngIf="isSubmitted && rejectionForm.controls['rejectionReason'].errors?.required"
      >
        {{genericVisuals.required}}
      </div>
      <div
        class="error"
        *ngIf="isSubmitted && rejectionForm.controls['rejectionReason'].errors?.maxlength"
      >
       {{genericVisuals.maxCharLength}} 250
      </div>
    </div>
    <div style="text-align: center;">
      <button type="submit" class="btn btn-success">{{ genericVisuals.submit }}</button>
    </div>
  </form>
</ng-template>


<div class="card"  *ngIf="!loading" >
  <div class="card-header">
    <strong>{{genericVisuals?.requestForApprovalGridTitle}}</strong>
    <a
        href="javascript:void(0);"
        role="button"
        class="pull-right"
        (click)="isCollapsed = !isCollapsed"
      >
        @if (isCollapsed) {
          <i class="fa fa-plus-circle"></i>
        } @else {
          <i class="fa fa-minus-circle"></i>
        }
      </a>
  </div>
  <div class="card-block p-0" [collapse]="isCollapsed">
    <requestsForApproval [selectorName]="tagName"></requestsForApproval>
  </div>
</div>
